import { configureStore, combineReducers } from "@reduxjs/toolkit";
import sessionReducer from "./slices/sessionSlice";
import feelingReducer from "./slices/feelingSlice";

import logger from "redux-logger";
import {
  persistReducer,
  persistStore,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from "redux-persist";
import storage from "redux-persist/lib/storage";

const rootReducer = combineReducers({
  session: sessionReducer,
  feeling: feelingReducer,
});

const persistConfig = {
  key: "root",
  version: 1,
  storage,
  whitelist: ["session", "feeling"], // Only persist selected reducers
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) => {
    const middlewares = getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    });

    if (process.env.NODE_ENV !== "production") {
      middlewares.push(logger); // Add redux-logger only in development mode
    }

    return middlewares;
  },
});

const persistor = persistStore(store);

export { store, persistor };
